import { useDashboardData } from "../context/DashboardDataContext";
import { formatPct } from "../dashboard/analytics";
import { Card } from "../components/ui/Card";
import { KpiCard } from "../components/ui/KpiCard";
import { PageHeader } from "../components/ui/PageHeader";
import { FunnelVertical } from "../components/charts/FunnelVertical";

export function AssessmentFunnel() {
  const { analytics } = useDashboardData();
  const { funnel } = analytics;
  const s = funnel.started || 1;
  const c = funnel.completed;
  const r = funnel.reportViewed;
  const t = funnel.ctaClicked;
  const p = funnel.paid;

  const stages = [
    { label: "Started", count: funnel.started, pct: "100%" },
    { label: "Completed", count: c, pct: formatPct(c / s) },
    { label: "Report viewed", count: r, pct: c ? formatPct(r / c) : "—" },
    { label: "CTA clicked", count: t, pct: r ? formatPct(t / r) : "—" },
    {
      label: "Paid client",
      count: p,
      pct: t ? formatPct(p / Math.max(1, t)) : r ? formatPct(p / Math.max(1, r)) : "—",
    },
  ];

  const dropItems = Object.entries(analytics.dropOff)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 8);

  return (
    <div className="page">
      <PageHeader
        eyebrow="Assessment funnel"
        title="Behavior & completion"
        description="Completion quality, time-on-task, and where unfinished sessions stall."
      />

      <div className="kpi-strip kpi-strip--dense">
        <KpiCard label="Starts" value={String(funnel.started)} />
        <KpiCard label="Completions" value={String(funnel.completed)} />
        <KpiCard label="Comp. rate" value={formatPct(analytics.completionRate)} />
        <KpiCard
          label="Median time (avg)"
          value={
            analytics.averageTimeMs
              ? `${Math.floor(analytics.averageTimeMs / 60000)}m ${Math.floor((analytics.averageTimeMs % 60000) / 1000)}s`
              : "—"
          }
        />
        <KpiCard label="Retake rate" value={formatPct(analytics.retakeRate)} />
        <KpiCard label="Abandonment (partial)" value={String(analytics.total - analytics.completed)} />
      </div>

      <div className="grid-2">
        <Card title="Funnel progression" subtitle="Volume at each milestone">
          <FunnelVertical stages={stages} />
        </Card>
        <Card title="Drop-off signal" subtitle="Last question reached when not completed">
          {dropItems.length ? (
            <ul className="stat-list">
              {dropItems.map(([q, n]) => (
                <li key={q}>
                  <span>{q}</span>
                  <strong>{n}</strong>
                </li>
              ))}
            </ul>
          ) : (
            <p className="muted">No partial submissions in this filter — drop-off will populate when users exit early.</p>
          )}
        </Card>
      </div>

      <Card title="Repeat assessments" subtitle="Score movement when the same email submits again">
        <p className="lead">
          Average change (latest − first overall %):{" "}
          <strong>{analytics.repeatDelta}%</strong>
        </p>
        <p className="muted small">
          Requires multiple rows per email in the dataset. Tune retake tracking in the assessment
          flow for stronger fidelity.
        </p>
      </Card>
    </div>
  );
}
